import type { TagProps } from "@caprikorn/dynamo-ui/lib/components/indicators/Tag/Tag.types";

export const getSemanticType = (variation: number | null) => {
  if (!variation) return "info";
  if (variation > 20) return "error";
  if (variation > 10) return "warning";

  return "success";
};

export const actionnableCode = [73, 72, 74, 75, 54, 56];
export const standByCode = [51, 70, 71, 52, 50, 80, 90];
export const processedCode = [55, 60];
export const errorCode = [53, 81, 99, 91, 92, 93];

export const getTagStatusColor = (code?: number): TagProps["color"] => {
  if (!code) return "default";

  if (processedCode.includes(code)) return "success";
  if (errorCode.includes(code)) return "error";
  if (actionnableCode.includes(code)) return "warning";
  if (standByCode.includes(code)) return "info";

  return "default";
};
